import React, { useState } from 'react';
import Popup from "../imagepopup";


function Sunlife() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setSelectedImage("");
  };
  return (
    
    <section className="sec-box project section-padding radius-15">
        <div className="next-prev">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="d-flex align-items-center">
              <div className="next ml-auto">
                <h6 className="sub-title back-to-work">
                  <a href="/works">
                  <i className="fas fa-long-arrow-alt-left"></i> Back to works
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-11">
          <div className="img mb-80">
            <img
              src="/assets/imgs/works/p42.jpg"
              alt=""
              className="radius-5"
            />
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <div className="cont md-mb50">
                <h3 className="mb-15 fw-500">Project Description:</h3>
                <p>Involved in Development life cycle of a Pega-based Insurance Quote System for Life Insurance, 
                  Express Critical Illness Insurance, and Personal Health Insurance. 
                  The application streamlined quote generation by automating data capture, 
                  premium calculations, and policy recommendations. Integrated external 
                  APIs for real-time data retrieval and ensured compliance with underwriting 
                  guidelines. Enhanced user experience with Pega UI/UX design and development with optimized workflows for 
                  efficiency, reducing manual processing and improving turnaround time.</p>
                <p className="mt-15">
                
                As a Center of Excellence (COE) team, driving UX/UI innovation and
standardization across Sun Life’s digital ecosystem. As a part of COE
team lead involved in multiple projects to manage and work as a UI
solution architect Designing and developing of Interface design and
accessibility features and functional additions where ever required.
                </p>
                <div className="mt-30">
                  <h6 className="mb-15 line-height-28">
                  Roles & Responsibilities:
                  </h6>
                  <ul className="rest list-arrow mt-50">
                    <li>
                    
                      <h6 className="inline fz-15">Involved in the “Insurance & Wealth” Applications Development Life
Cycle phases like Requirement Analysis, Implementation and
estimating the time-lines for the project.</h6>
                    </li>
                    <li className="mt-20">
                    
                      <h6 className="inline fz-15">
                      Working in Agile /Scrum methodology with two weeks Sprint
sessions, and daily Scrums to discuss the development of the
application by quick responding to change.
                      </h6>
                    </li>
                    <li className="mt-20">
                    
                      <h6 className="inline fz-15">Successfully implemented streamlined information architecture and
                      navigation mo dels.</h6>
                    </li>
                    <li className="mt-20">
                    
                      <h6 className="inline fz-15">Designed Out of box Custom components that were scalable and
                      reusable across all future projects.</h6>
                    </li>
                    <li className="mt-20">
                    
                      <h6 className="inline fz-15">Developing customized Pega Skin for all applications across all
Pega Labs for Sunlife and creating Responsive Interface with
customized UI components based on application requirements.</h6>
                    </li>
                    <li className="mt-20">
                    
                      <h6 className="inline fz-15">Analyzed and reviewed whether Sunlife Branding Guidelines are
                      maintained for the UI Components developed on the Pega Platform.</h6>
                    </li>
                    <li className="mt-20">
                    
                      <h6 className="inline fz-15">Authored User Interface specification document to help developers
understand the interactions and deploy the final product as per the
specifications.</h6>
                    </li>
                    <li className="mt-20">
                    
                      <h6 className="inline fz-15">Involving in team meetings and working with Project Architect
                      interaction types and resolving functionality based issues.</h6>
                    </li>
                    <li className="mt-20">
                    
                      <h6 className="inline fz-15">Debugging and resolving issues during development and
production phases. Publishing the approved items in the form of
Tests to the customers.</h6>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="info sub-bg" id="sticky_item">
                <ul>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="far fa-calendar-alt mr-10"></i> Date :
                    </span>
                    <p>June 2019</p>
                  </li>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="fas fa-list-ul mr-10"></i> Categories :
                    </span>
                    <p> UI/UX Lead (COE Team).</p>
                  </li>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="far fa-user mr-10"></i> Client :
                    </span>
                    <p>Sunlife</p>
                  </li>
                  <li>
                    <span className="sub-title">
                      <i className="fas fa-globe mr-10"></i> Website :
                    </span>
                    <p>https://www.sunlife.ca/en/get-a-quote/</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="imgs mt-80">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="row md-marg">
              <div className="col-md-6">
                <div className="img sm-mb30">
                  <img src="/assets/imgs/works/p46.jpg" alt="" onClick={() => handleImageClick("/assets/imgs/works/p46.jpg")} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="img">
                  <img src="/assets/imgs/works/p47.jpg" alt="" onClick={() => handleImageClick("/assets/imgs/works/p47.jpg")} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="next-prev">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="d-flex align-items-center mt-80 pt-80 bord-thin-top">
              <div className="prev">
                <h6 className="sub-title">
                  <a href="/ford">
                    <i className="fas fa-long-arrow-alt-left"></i> Prev Project
                  </a>
                </h6>
              </div>
              <div className="next ml-auto">
                <h6 className="sub-title">
                  <a href="/cibc">
                    next Project <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      
                  {/* Popup for images */}
                  <Popup
        isOpen={isPopupOpen}
        closePopup={closePopup}
        popupImage={selectedImage}
      />
    </section>
  );
}

export default Sunlife;
